import $ from 'jquery'

export function initUpload (uploadAPI, elements, errorPage) {
  const _uploadUrl = uploadAPI
  const _uploads = elements
  const _errorPage = errorPage

  // console.log("upload-popup-form ready! --> " + uploadUrl);
  if (_uploadUrl && _uploads.length) {
    _uploads.each(function () {
      const $uploadContainer = $(this),
        $upload = $uploadContainer.find('.upload'),
        $errorFileSize = $uploadContainer.find('.file-size'),
        $errorFileType = $uploadContainer.find('.file-type'),
        $fileMeta = $uploadContainer.find('.file-meta'),
        $fileName = $uploadContainer.find('.file-name'),
        $progressBar = $uploadContainer.find('.upload-progress-bar'),
        $progressBarFill = $progressBar.find('.progress-bar-fill'),
        $remove = $uploadContainer.find('.upload-remove'),
        $uploadURL = $uploadContainer.find('.upload-url')

      let uploadStatus

      $upload.fileupload({
        url: _uploadUrl,
        method: 'POST',
        dataType: 'json',
        autoUpload: true,
        add: function (e, data) {
          let uploadErrors = []
          let acceptFileTypes = /(\.|\/)(pdf|jpg|jpeg)$/i
          let acceptFileSize = 5 * 1024 * 1024

          if (data.originalFiles[0]['name'].length && !acceptFileTypes.test(data.originalFiles[0]['name'])) {
            uploadErrors.push('fileType')
          }

          if (data.originalFiles[0]['size'] > acceptFileSize) {
            uploadErrors.push('fileSize')
          }

          if (uploadErrors.length > 0) {
            if (uploadErrors.indexOf('fileType') != -1) {
              $errorFileSize.removeClass('not-valid')
              $errorFileType.addClass('not-valid')
            }
            if (uploadErrors.indexOf('fileSize') != -1) {
              $errorFileType.removeClass('not-valid')
              $errorFileSize.addClass('not-valid')
            }
          } else {
            if (!uploadStatus) {
              $errorFileSize.removeClass('not-valid')
              $errorFileType.removeClass('not-valid')
              uploadStatus = true
              $upload.hide()
              $fileName.text(data.files[0]['name'])
              $fileMeta.attr('data-fileType', data.files[0].type)
              $fileMeta.css('display', 'flex')
              $progressBar.css('display', 'flex')
              $remove.show()
              data.submit()
            }
          }
        },
        done: function (e, data) {
          // console.log("file uploaded: ", data.result);
          $uploadURL.val(data.result['filePath'])
          uploadStatus = false
          $uploadContainer.next('.upload-js.d-none').first().removeClass('d-none')
          $uploadContainer.parent().find('label.error').remove()
        },
        fail: function (e, data) {
          // console.log("upload fail: ", data.jqXHR.responseText);
          uploadStatus = false
        },
        progressall: function (e, data) {
          let progress = parseInt(data.loaded / data.total * 100, 10)
          // console.log("... upload progress: ", progress);
          if (uploadStatus) {
            $progressBarFill.css(
              'width',
              progress + '%'
            )

            $progressBarFill.text(progress + '%')

            if (progress == 100) {
              uploadStatus = false
            }
          }
        }
      })
        .prop('disabled', !$.support.fileInput)
        .parent().addClass($.support.fileInput ? undefined : 'disabled')

      $remove.find('.btn').on('click', function () {
        $progressBarFill.css('width', '0%')
        $upload.show()
        $fileName.text('')
        $progressBar.hide()
        $fileMeta.hide()
        $remove.hide()
        $uploadURL.val('')
      })
    })
  }
}
